export default __webpack_public_path__ + "static/media/genderSelected.7a383245.svg";